module.exports = __webpack_public_path__ + "static/media/mmm-off-app-provider-icon.29edb799.svg";